import React, { useContext } from 'react'
import { LinearProgress } from '@mui/material'
import { LoadingContext } from './loading.context'
import { useTranslation } from "react-i18next"
import PropTypes from 'prop-types'
import '../index.css'

export function LoadingBar({ laneColor, gif }) {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  const color = laneColor || ctx.primaryColor || "var(--color-black)"

  return (
    <>
      {laneColor ?
        <LinearProgress
          data-testid="linear-progress"
          style={{ height: '5px' }}
          sx={{
            backgroundColor: 'var(--color-grey-light)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: color
            }
          }}
        /> :
        <div
          data-testid="loading-container"
          style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {gif ? <>{gif}</> : <img src="./images/loading-gif.gif" style={{ width: 'auto', height: '100px', opacity: '50%', marginBottom: '10px' }} alt='LoadingImg' />}
          </div>
          <div className="loader-container">
            <div className="loading-text" style={{ color: ctx.primaryColor || 'var(--color-black)' }}>{t("LabelLoading")}<span className="dots"></span></div>
          </div>
        </div>
      }
    </>
  )
}

LoadingBar.propTypes = {
  laneColor: PropTypes.string,
  gif: PropTypes.node
}